import React, { useEffect, useState } from 'react';

import Axios from 'axios';
import Head from 'next/head';

import getMetaTagData from '../../../src/common/services/getMetaTagData';

import Loading from '../../../src/component/m/common/Loading';
// import AdBanner from '../../../src/component/';
import Slider from '../../../src/component/m/carousel/Slider';
import Title from '../../../src/component/m/common/Title';
import AdGenerater from '../../../src/component/m/ads/AdGenerater.js';

import { deduplArray, toTimeStamp } from '../../../src/common/utils/convertUtil';
import { getLiveChannelType, getLivePlanArray, toPlanUrl } from '../../../src/common/utils/liveUtil';

const LiveViewPage = (props) => {
  const [channelType, setChannelType] = useState('tv');

  const onair = props.data?.onair || null;

  useEffect(() => {
    if (onair && onair.info.channelid) {
      setChannelType(getLiveChannelType(onair.info.channelid));
    }

    if (process.env.NODE_ENV === 'production') {
      let tagId, ga4TagId;
      switch (onair.info.channelid) {
        case 'S02': // sbs sports
          tagId = 'UA-146376328-1';
          ga4TagId = 'G-8G453WZ76V';
          break;
        case 'S03': // sbs plus
          tagId = 'UA-146760740-2';
          ga4TagId = 'G-97W8RH442C';
          break;
        case 'S04': // sbs fune
          tagId = 'UA-146760740-3';
          ga4TagId = 'G-WQWE5WDT9F';
          break;
        // case 'S05': // sbs golf
        //   tagId = 'UA-100348188-1';
        //   break;
        case 'S06': // sbs biz
          tagId = 'UA-135761934-1';
          break;
        case 'S09': // sbs m
          tagId = 'UA-146888827-4';
          ga4TagId = 'G-0DM6QEB0KJ';
          break;
        case 'S10': // kizmom, S20 kpop, 
          tagId = 'UA-146888827-5';
          ga4TagId = 'G-YHQ768DD4V';
          break;
        default:
          tagId = null;
          ga4TagId = null;
          break;
      }

      if (tagId) {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', tagId, {
          page_location: window.location.href,
          page_path: window.location.pathname,
          page_title: window.document.title
        });
        if (ga4TagId) gtag('config', ga4TagId);
      }
    }
  }, [onair]);

  return (
    <div className='contents'>
      <script async src='https://www.googletagmanager.com/gtag/js?id=UA-146376328-1' type='text/javascript' />
      <Head>
        <link rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_M_URL} />
        <meta name='viewport' content='user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width' />
        <script type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />
        <meta name='description' content={props.metaTagData.shareDescription} />
        <meta name='keywords' content={props.metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={props.metaTagData.shareTitle || ''} />
        <meta property='og:description' content={props.metaTagData.shareDescription || ''} />
        <meta property='og:image' content={props.metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={props.metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={props.metaTagData.shareTitle || ''} />
        <meta name='nate:description' content={props.metaTagData.shareDescription || ''} />
        <meta name='nate:image' content={props.metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={props.metaTagData.currentUrl || ''} />
        <title>{props.metaTagData.shareTitle}</title>
      </Head>

      <div role='main' id='container' className='live_end_wrap'>
        <div className="contents_middle_ad">
          <div className="middle_ad_inner">
            <iframe title='배너광고' src="/html/m/live_mo_middle_320100.htm" width="320" height="100" scrolling="no" allowtransparency="ture" style={{ border: 0, margin: '0px' }}></iframe>
          </div>
        </div>

        {(!Array.isArray(props.schedules) || props.schedules.length <= 0) && (``)}
        {onair && (Array.isArray(props.schedules) && props.schedules.length > 0) && (
          <div className='contents_area_schedule'>
            <Title title={`${(onair.info.channelid === 'S19') ? '고릴라M' : onair.info.channelname} 편성표`} desc='전체 편성표' link={toPlanUrl(onair.info.channelid)} />
            <Slider type='schedule' clickParams='div=live_end' data={props.schedules} />
          </div>
        )}

        {(Array.isArray(props.channels.tv) && props.channels.tv.length > 0) && (
          <div className='contents_area_live'>
            <Title title='라이브 TV' />
            <Slider type='thumb' clickParams='div=live_end' data={props.channels.tv} />
          </div>
        )}

        {(Array.isArray(props.channels.radio) && props.channels.radio.length > 0) && (
          <div className='contents_area_live'>
            <Title title='라이브 라디오' />
            <Slider type='thumb' clickParams='div=live_end' data={props.channels.radio} />
          </div>
        )}

        {(Array.isArray(props.channels.virtual) && props.channels.virtual.length > 0) && (
          <div className='contents_area_live'>
            <Title title='24시간 TV' />
            <Slider type='thumb' clickParams='div=live_end' data={props.channels.virtual} />
          </div>
        )}

        {(props.vods && Array.isArray(props.vods.list) && props.vods.list.length > 0) && (
          <div className='contents_area_vod'>
            <Title title={props.vods.title} />
            <Slider type='thumb' relate_id='vod' relate_type={props.vods.type} clickParams='div=live_end' data={props.vods.list} />
          </div>
        )}

        {(props.clips && Array.isArray(props.clips.list) && props.clips.list.length > 0) && (
          <div className='contents_area_clip'>
            <Title title={props.clips.title} />
            <Slider type='thumb' relate_id='clip' bottom_type='live_recommand_clip' clickParams='div=live_end' data={props.clips.list} />
          </div>
        )}
      </div>
    </div>
  );
};

export async function getServerSideProps(ctx) {
  // 가상 또는 라디오채널은 채널이름 명확하지 않아 채널아이디로 하는게 좋아보임
  const channelID = ctx.params.channelID;
  const channelType = getLiveChannelType(channelID);

  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const metaTagData = getMetaTagData(ctx.req.url, channelID);

  const data = await onairData(channelID, channelType);
  if (data?.onair?.info.title) {
    metaTagData.shareTitle += data.onair.info.title;
  }

  const channelName = (data === null) ? '채널정보 없음' : (channelID === 'S19') ? '고릴라M'
    : (data && data.onair !== undefined) ? data.onair.info.channelname : '';
  const channels = await channelData(channelID);
  const plan = await getLivePlanArray(channelID, true);

  let vodType, vodTitle, clipTitle, vodData, clipData, _vodData, _clipData, _vodArray, _clipArray;
  if (data && (data.onair.info.smr_programid || data.onair.info.vod_mediaids || data.onair.info.clip_mediaids)) {
    try {
      const recommandVodApiUrl = `${process.env.API_LIVE_RECOMMAND_VOD}/new/${data.onair.info.smr_programid}`;
      _vodData = await Axios.get(recommandVodApiUrl, { timeout: 3000 });
      _vodArray = _vodData.data;

      if (_vodArray.length > 0) {
        vodType = 'vod';
        vodTitle = `${(_vodArray[0]?.pgm_nm ? _vodArray[0].pgm_nm + ' ' : '')}최신 VOD`;
        vodData = Array.isArray(_vodArray)
          ? _vodArray.map(x => ({
            relate_type: 'vod',
            srs_div: '01',
            content_date: x.content_date || null,
            content_num: x.content_num || null,
            content: x.content || null,
            title: x.title,
            img: x.pgm_img_url,
            info: { title: x.pgm_nm, desc: x.title },
            link: x.link_url || 'https://www.sbs.co.kr'
          }))
          : null;
      } else {
        vodType = 'curation_vod';
        _vodData = await Axios.get(process.env.API_LIVE_RECOMMAND_VOD_ALL, { timeout: 3000 });
        _vodArray = _vodData.data;
        vodTitle = '최신 VOD';
        vodData = Array.isArray(_vodArray)
          ? _vodArray.map(x => ({
            relate_type: 'curation_vod',
            content_date: x.content_date || null,
            content_num: x.content_num || null,
            date: '',
            desc: x.pgm_nm || x.title,
            img: x.pgm_img_url || x.thumb.small,
            imgDesc: x.pgm_nm || null,
            pgm_nm: x.pgm_nm || null,
            srs_div: '01',
            srs_dtl_no: '',
            title: x.pgm_nm || x.title,
            srs_no: x.content_num || null,
            link: x.link_url || 'https://www.sbs.co.kr'
          }))
          : null;
      }
    } catch (e) {
      console.error(e);
    }

    try {
      if (channelType !== '24tv') {
        const recommandClipApiUrl = `${process.env.API_LIVE_RECOMMAND_CLIP}/top/${data.onair.info.smr_programid}`;
        _clipData = await Axios.get(recommandClipApiUrl, { timeout: 3000 });
        _clipArray = (channelType !== '24tv') ? _clipData.data : _clipData.data.list;
        clipTitle = `${(_clipArray[0]?.pgm_nm ? (_clipArray[0].pgm_nm === 'GorealraM' ? '고릴라M' : _clipArray[0].pgm_nm) + ' ' : '')}인기 클립`;
      } else {
        _clipData = await Axios.get((channelType !== 'radio') ? process.env.API_LIVE_RECOMMAND_CLIP_ALL : process.env.API_LIVE_RECOMMAND_RADIO_ALL, { timeout: 3000 });
        _clipArray = _clipData.data;
        clipTitle = '인기 클립';
        clipData = Array.isArray(_clipArray) ? _clipArray.map(x => ({ time: toTimeStamp(x.playtime), title: x.title, desc: x.pgm_nm || channelName, img: x.pgm_img_url || x.thumb.small, link: x.link_url || 'https://www.sbs.co.kr' })) : null;
      }

      if (_clipArray.length === 0) {
        _clipData = await Axios.get((channelType !== 'radio') ? process.env.API_LIVE_RECOMMAND_CLIP_ALL : process.env.API_LIVE_RECOMMAND_RADIO_ALL, { timeout: 3000 });
        _clipArray = _clipData.data;
        clipTitle = channelName + ' 인기 클립';
      }

      clipData = Array.isArray(_clipArray)
        ? _clipArray.map(x => ({
          title: x.title,
          desc: x.pgm_nm || channelName,
          img: x.pgm_img_url || x.thumb.small,
          link: x.link_url || 'https://www.sbs.co.kr'
        }))
        : null;
    } catch (e) {
      console.error(e);
    }
  } else {
    try {
      vodType = 'curation_vod';
      _vodData = await Axios.get(process.env.API_LIVE_RECOMMAND_VOD_ALL, { timeout: 3000 });
      _vodArray = _vodData.data;
      vodTitle = '최신 VOD';
      vodData = Array.isArray(_vodArray)
        ? _vodArray.map(x => ({
          relate_type: 'curation_vod',
          content_date: x.content_date || null,
          content_num: x.content_num || null,
          date: '',
          desc: x.pgm_nm || x.title,
          img: x.pgm_img_url || x.thumb.small,
          imgDesc: x.pgm_nm || null,
          pgm_nm: x.pgm_nm || null,
          srs_div: '01',
          srs_dtl_no: '',
          title: x.pgm_nm || x.title,
          srs_no: x.content_num || null,
          link: x.link_url || 'https://www.sbs.co.kr'
        }))
        : null;

      _clipData = await Axios.get((channelType !== 'radio') ? process.env.API_LIVE_RECOMMAND_CLIP_ALL : process.env.API_LIVE_RECOMMAND_RADIO_ALL, { timeout: 3000 });
      _clipArray = _clipData.data;
      clipTitle = '인기 클립';
      clipData = Array.isArray(_clipArray)
        ? _clipArray.map(x => ({
          time: toTimeStamp(x.playtime),
          title: x.title,
          desc: x.pgm_nm || channelName,
          img: x.pgm_img_url || x.thumb.small,
          link: x.link_url || 'https://www.sbs.co.kr'
        }))
        : null;
    } catch (e) {
      console.error(e);
    }
  }

  let programLikeCnt;
  if (data && data.onair.info.programid) {
    try {
      const likeCnt = await Axios.get(process.env.API_LIVE_PROGRAM_LIKE_COUNT + '/' + data.onair.info.smr_programid, { timeout: 3000 });
      programLikeCnt = (likeCnt.data)?.count;
    } catch (e) {
      console.error(e);
    }
  }

  let chatData;
  try {
    const _chatData = await Axios({
      method: 'get',
      url: `${process.env.API_LIVE_CHATTING_CHANNELS}/${channelID}`,
      headers: {
        'Content-Type': 'application/json',
        Host: ''
      },
      timeout: 3000
    });
    chatData = (_chatData.data.channelid === channelID) ? _chatData.data : null;
  } catch (e) {
    console.error(e);
  }

  let emoticonData;
  try {
    const _emoticonData = await Axios.get(process.env.API_LIVE_CHATTING_EMOTICONS, { timeout: 3000 });
    emoticonData = _emoticonData.data;
  } catch (e) {
    console.error(e);
  }

  const apis = {
    info: process.env.API_LIVE_INFO,
    chatting_channel: process.env.API_LIVE_CHATTING_CHANNELS,
    chatting_user: process.env.API_LIVE_CHATTING_USER,
    chatting_report: process.env.API_LIVE_CHATTING_REPORT,
    translate: process.env.URL_LIVE_TRANSLATE_SOCKET,
    like: process.env.API_LIVE_PROGRAM_LIKE_SEND
  };

  return {
    props: {
      data: data || null,
      schedules: plan || null,
      channels: channels || null,
      vods: (vodType && vodTitle && vodData) ? { type: vodType, title: vodTitle, list: vodData } : null,
      clips: (clipTitle && clipData) ? { title: clipTitle, list: clipData } : null,
      like_cnt: programLikeCnt || null,
      chats: chatData || null,
      emoticons: emoticonData || null,
      apis: apis || null,
      metaTagData
    }
  };
}

const onairData = async (channelID, channelType) => {
  try {
    const apiChannelPath = (channelType !== '24tv') ? 'channel' : 'virtual/channel';
    const infoApiUrl = `${process.env.API_LIVE_INFO}/${apiChannelPath}/${channelID}?v_type=2&platform=pcweb&protocol=hls&ssl=N&rscuse=&jwt-token=&sbsmain=`;

    const res = await Axios.get(infoApiUrl, { timeout: 3000 });
    const data = res.data;

    return data;
  } catch (e) {
    console.error(e);
  }
};

const channelData = async (channelID) => {
  try {
    const tvChannelList = await Axios.get(process.env.NEXT_PUBLIC_API_LIVE_CHANNELS, { timeout: 3000 });
    // * 멀티오디오 추가로 중복채널 제거 로직 검토 필요
    //let channelTVData = tvChannelList.data.list.filter((item) => (item.type === 'TV' && item.channelid !== channelID));
    let channelTVData = tvChannelList.data.list.filter((item) => (item.type === 'TV'));
    channelTVData = channelTVData.map(x => ({
      title: x.title,
      channelid: x.channelid, // 저지연, 멀티오디오 라벨 표시를 위해 추가
      desc: x.channelname,
      link: `/live/${x.channelid}`,
      pgm_title: x.title,
      img: (x.channelid !== 'EVENT4') ? x.thumbs?.['640'] || x.thumbimg || x.program_image : x.thumbimg,
      starttime: x.starttime || null,
      endtime: x.endtime || null
    }));

    const radioChannelList = await Axios.get(process.env.NEXT_PUBLIC_API_LIVE_CHANNELS, { timeout: 3000 });
    const dupRadioArray = radioChannelList.data.list.filter((item) => (item.type === 'Radio' && item.onair_yn === 'Y'));
    let channelRadioData = deduplArray(dupRadioArray, 'channelname', 'channelid');
    channelRadioData = channelRadioData.map(x => ({
      title: x.title,
      desc: (x.channelid === 'S19') ? '고릴라M' : x.channelname,
      link: `/live/${x.channelid}`,
      channelid: x.channelid,
      pgm_title: x.title,
      img: x.thumbs?.['640'] || x.thumbimg || x.program_image,
      starttime: x.starttime || null,
      endtime: x.endtime || null
    }));

    const virtualChannelList = await Axios.get(process.env.NEXT_PUBLIC_API_LIVE_CHANNELS_24TV, { timeout: 3000 });
    let channel24Data = virtualChannelList.data.list.filter((item) => (item.channelid !== channelID));
    channel24Data = channel24Data.map(x => ({
      title: x.title,
      desc: x.channelname,
      link: `/live/${x.channelid}`,
      pgm_tms_title: x.title,
      img: x.thumbs?.['640'] || x.thumbimg || x.program_image,
      starttime: x.starttime || null,
      endtime: x.endtime || null
    }));

    return { tv: channelTVData, radio: channelRadioData, virtual: channel24Data };
  } catch (e) {
    console.error(e);
  }
};

export default LiveViewPage;